import { capitalize, capitalizeAllWords } from 'src/utilities/capitalize';
import { toLower } from 'ramda';
import { buildLabel } from 'src/utilities/naming';
import { ROLE_BORROWER, ROLE_COBORROWER } from 'src/constants';
//// The version of the REST API
export const V1 = 'v1';

//// All the kinds of schema we support in the REST API
export const KIND_LOANAPP = 'LoanApp';
export const KIND_ACCOUNT = 'Account';
export const KIND_ASSIGNEE_ACCOUNT = 'AccountAssignee';
export const KIND_LOANAPP_ROLE = 'LoanAppRole';

export const KIND_LOAN_STATUS = 'LoanStatus';
export const KIND_LENDING_TERM = 'LendingTerm'
export const KIND_PROPERTY = 'Property'
export const KIND_BORROWER = "Borrower"
export const KIND_BUSINESS = "Business"
export const KIND_WORKFLOW_INTENT = "WorkflowIntent"
export const KIND_DECLARAION = "Declaration"
export const KIND_EMPLOYMENT = 'Employment'
export const KIND_BANK_ACCOUNT = 'BankAccount'
export const KIND_COLLATERAL = 'Collateral'


export const KIND_DOCUMENT_ACCESS_CONTROL = 'DocumentAccessControl';

export const KIND_ADVISOR_PROFILE = 'AdvisorProfile';

export const KIND_TEAM_MEMBER = 'TeamMember';

export const KIND_MONTHLY_INCOME = 'MonthlyIncome';

export const KIND_ROLES = 'Roles';

export const KIND_CREDIT_REPORT = 'CreditReport';

export const KIND_CREDIT_REPORT_LIST = 'CreditReportList';
export const KIND_TASK = 'Task';
export const KIND_APPROVAL = 'Approval';
export const KIND_FEED_AUDIT = 'FeedAudit';
export const KIND_ORIGINATING_LOAN_PERMISSION = 'OriginatingLoanPermission';

export const UI_WORKFLOW_BOT = "UI Workflow Bot"

export const SIGNATURE_TYPE = buildLabel('signature_type');


export const ENTITY_ALL = 'entity=all'
export const WORKFLOW_PULL = 'workflow=yes'

export type ApiResource = 'user_accounts' | 'loanapp_roles' |
  'borrowers' |
  'lending_terms' |
  'monthly_incomes' |
  'employments' |
  'properties' |
  'real_estate_asset' |
  'assests' |
  'additional_loan' |
  'loan_status' |
  'liabilities' |
  'declarations' |
  'business' |
  'business_incomes' |
  'workflow_intents' |
  'collateral'



export const API_RESOURCE = 'api_resource';
// Following are API resource keys
// mortgage related resources
export const API_RESOURCE_BORROWERS = "borrowers"
export const API_RESOURCE_MONTHLY_INCOMES = "monthly_incomes"
export const LOAN_APP = "loanapps"
export const API_RESOURCE_EMPLOYMENTS = "employments"
export const API_RESOURCE_COLLATERAL = "collateral"

export const API_RESOURCE_LOANAPP_ROLES = "loanapp_roles"
export const API_RESOURCE_ASSETS = "assests" // also we refer as bank_statements on DB
export const API_RESOURCE_LIABILITIES = "liabilities" // also we refer as credit_reports on DB
export const API_RESOURCE_LOAN_STATUS = "loan_status"
export const API_RESOURCE_LENDING_TERMS = "lending_terms"
export const API_RESOURCE_PROPERTIES = "properties"
export const API_RESOURCE_REAL_ESTATE_ASSET = "real_estate_asset"
export const API_RESOURCE_ADDITIONAL_LOAN = "additional_loan"
export const API_RESOURCE_DECLARATIONS = "declarations"
export const API_RESOURCE_TEAMS = "teams"
export const API_RESOURCE_USER_ACCOUNTS = "user_accounts"

export const API_RESOURCE_BUSINESS = "business"
export const API_RESOURCE_BUSINESS_INCOMES = "business_incomes"
export const API_RESOURCE_WORKFLOW_INTENTS = "workflow_intents"
export const API_RESOURCE_LOAN_APPS = "loanapps"


export const DEEDSY_SH_BORRWER = buildLabel(ROLE_BORROWER);
export const DEEDSY_SH_COBORRWER = buildLabel(ROLE_COBORROWER);

export const LO_100_PERCENT_MATCHED = 5;
// Must be string number
export const DEFAULT_DOCUMENT_PAGE_LIMIT = '3';

// Mail notification labels
export const ASSIGNOR_NAME = buildLabel('assignor_name');
export const ASSIGNOR_EMAIL = buildLabel('assignor_email');
export const ASSIGNEE_NAME = buildLabel('assignee_name');
export const ASSIGNEE_EMAIL = buildLabel('assignee_email');
export const ASSIGNEE_PHONE = buildLabel('assignee_phone');
// task redirect URL
export const TASK_REDIRECT_URL = buildLabel('return_to');


export const DOCUMENT_CATEGORY_PL = 'Last Profit and Loss Statement';


export const DOCUMENT_REPRESENTS_ID = 'ID';
export const DOCUMENT_REPRESENTS_BANKSTATEMENT = 'Bank statement';

export const DOCUMENT_REPRESENTS_PAYSTUBS = 'Pay stubs';
export const DOCUMENT_REPRESENTS_W2 = 'W2';
export const DOCUMENT_REPRESENTS_1099 = '1099';


export const SUCCESS_UPPERCASE_S = 'Success';
export const FAILED_UPPERCASE_F = 'Failed';

export const META_DATA = 'metadata';
export const OBJECT_META = 'object_meta';
export const TYPE_META = 'type_meta';
export const ACCOUNT = 'account';
export const LABELS = 'labels';
export const CATEGORY = 'category';
export const OWNER_REFERENCES = 'owner_references';
export const ACTOR_WORKLET = 'Worklet';


// LoanRoles
export const DEEDSY_SH_BORROWER = buildLabel('borrower');
export const DEEDSY_SH_COBORROWER = buildLabel('coborrower');

/////////////////////////////////////////////////////////////
/* There 2 roles here why is this needed?
 * We need to move this our

 */

/** Don't use camelCase in Rustlang */
export const MERCHANT_CASH_ADVANCE = 'fund_a_loan';
export const DEEDSY_SH_MERCHANT_CASH_ADVANCES = buildLabel(
  MERCHANT_CASH_ADVANCE
);


/////////////////////////////////////////////////////////////
export const DEFAULT_PASSWORD = 'Speed#123';
export const APPLICATION_FILLEDBY = buildLabel('application_filled_by');
export const APPLICATION_CREATEDBY = buildLabel('application_created_by');
export const LOAN_CLASS = buildLabel('loan_class');
export const APPLICATION_LAUNCHER_TYPE = buildLabel('application_launcher_type');


export const LOAN_PRODUCT_ID = buildLabel('loan_product_id');
export const ADVISOR_ID = buildLabel('advisor_id');
export const DEEDSY_SH_MLS_ID = buildLabel('mls_id');

export const DEEDSY_SH_BUSINESS_LOCATION = buildLabel('business_location');
export const DEEDSY_SH_DISPLAY_LOCATION = buildLabel('display_location');


///
export const YES_DOWNCASE = 'yes';
export const NO_DOWNCASE = 'no';
export const TRUE_DOWNCASE = 'true';
export const FALSE_DOWNCASE = 'false';

export const NA = 'n/a';
/// This is Yes
export const YES_UPPERCASE_Y = capitalize(YES_DOWNCASE);
/// This is No
export const NO_UPPERCASE_N = capitalize(NO_DOWNCASE);
export const IS_OWN_BUILDER = "Own"

/// This is Yes
export const YES_CAPITALIZED = capitalizeAllWords(YES_DOWNCASE);
/// This is No
export const NO_CAPTITALIZED = capitalizeAllWords(NO_DOWNCASE);


export const SHORTNAME_BU = 'BU';
export const SHORTNAME_GU = 'GU';


export const INVITE_MY_COBORROWER = buildLabel('invite_my_coborrower');
export const INVITE_MY_ADVISOR = buildLabel('invite_my_advisor');


// Template Metadata Keys
export const INVITE_TO_PERSONA = 'invite_to_persona';

// Smart match type

// SMART MARTCH API TYPES
export const SMARTMATCH_TYPE_ISO = 'iso';
export const SMARTMATCH_TYPE_ADMIN_ISO = 'adminiso';

export const SMARTMATCH_TYPE_REALTOR = 'realtors';
export const SMARTMATCH_TYPE_ADVISOR = 'advisor';
export const SMARTMATCH_TYPE_COBORROWER = 'coborrower';
export const SMARTMATCH_TYPE_BORROWER = 'borrower';
export const SMARTMATCH_TYPE_TAX_ATTORNEY = 'tax_attorneys';
export const SMARTMATCH_TYPE_TAX_ACCOUNTANT = 'tax_accountant';
export const SMARTMATCH_TYPE_HOME_INSURANCE = 'home_insurances';
export const SMARTMATCH_TYPE_HOME_INSPECTOR = 'home_inspectors';
export const SMARTMATCH_TYPE_LOAN_OFFICER = 'loan_officers';
export const SMARTMATCH_TYPE_CREDIT_MANAGER = 'credit_manager';
export const SMARTMATCH_TYPE_RATE_APPROVER = 'rate_approval_manager';
export const SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER = 'adminloanofficer';
export const SMARTMATCH_TYPE_CLOSER = 'closer';
export const SMARTMATCH_TYPE_MOVER = 'movers';
export const SMARTMATCH_TYPE_APPRAISER = 'appraiser';
export const SMARTMATCH_TYPE_UNDER_WRITER = 'underwriter';
export const SMARTMATCH_TYPE_TITLE_AGENCY = 'title agency';
export const SMARTMATCH_TYPE_LOAN_PROCESSOR = 'loan_processor';
export const SMARTMATCH_TYPE_LOAN_ASSISTANT = 'loan_assistant';
export const SMARTMATCH_TYPE_LOAN_PROCESSOR_READER = 'loan_processor_reader';
export const SMARTMATCH_TYPE_FUNDING_SPECIALIST = 'funding_specialist';
export const SMARTMATCH_TYPE_BACKEND_OFFICER = 'backend_officer';
export const SMARTMATCH_TYPE_ACCOUNTING = 'accounting';
export const SMARTMATCH_TYPE_SALES = 'sales';
export const SMARTMATCH_TYPE_SALES_ADMIN = 'sales_admin';
export const SMARTMATCH_TYPE_ADMIN = 'admin';
export const SMARTMATCH_TYPE_HIGH_CREST = 'high_crest';
export const SMARTMATCH_TYPE_RELATIONSHIP_MANAGER = 'relationship_manager';




export const DOCUMENT_CLOSING_LABEL = buildLabel('closing');
export const DOCUMENT_CLOSING_RIGHT_SIDE_LABEL =
  buildLabel('closing_right_side');
export const DOCUMENT_CLOSING_LEFT_LABEL = buildLabel('closing_left_side');
export const DOCUMENT_CLOSING_CONDITION_LABEL =
  buildLabel('closing_conditions');
export const DOCUMENT_APPRAISAL_LABEL = buildLabel('appraisal');
export const DOCUMENT_TITLE_COMMITMENT_LABEL = buildLabel('title_commitment');
export const DOCUMENT_DU_FINDING_LABEL = buildLabel('du_finding');
export const DOCUMENT_FLOOD_CERTIFICATION_LABEL = buildLabel(
  'flood_certification'
);

// Advisor Task Types

export const ADVISOR_ISO = 'ISO';
export const ADVISOR_ADMINISO = 'ISO (Admin)';
export const ADVISOR_ACCOUNTING = 'Accounting';
export const ADVISOR_SALES = 'Sales';
export const ADVISOR_ADMINSALES = 'Sales (Admin)';
export const ADVISOR_HIGH_CEREST = 'High Crest';
export const ADVISOR_SUPER_ADMIN = 'Global Admin';

export const ADVISOR_REALTOR = 'Realtor';
export const HOME_INSURANCE = "Home Insurance"
export const COLLATERAL_INSURANCE = "Insurance"
export const CHECKING_AND_SAVING_ACCOUNT = "Checking and Savings Account"
export const ADVISOR_LOANOFFICER = 'Loan Officer';
export const ADMIN_LOANOFFICER = 'Loan Officer (Admin)';
export const ADVISOR_ATTORNEY = 'Real Estate Attorney';
export const ADVISOR_ACCOUNTANT = 'Tax Accountant';
export const ADVISOR_INSPECTOR = 'Home Inspector';
export const ADVISOR_INSURANCE = 'Home Insurance provider';
export const ADVISOR_FUNDING_SPECIAILIST = 'Funding Specialist';
export const BACKEND_OFFICER = 'Backend Officer';
export const LOAN_OFFICER_BACKEND = 'Loan Officer (Backend)';
export const ADVISOR_MOVER = 'Moving company';
export const ADVISOR = 'Reviewer';
export const APPRAISER = 'Appraiser';
export const UNDER_WRITER = 'Underwriter';
export const ADMIN_UNDER_WRITER = 'Underwriter (Admin)';
export const LOAN_PROCESSOR = 'Loan Processor';
export const LOAN_PROCESSOR_READER = 'Loan Processor (Read Only)';
export const TITLE_AGENCY = 'Title agency';
export const HOME_BUYER = 'Home Buyer';
export const COBORROWER = 'Coborrower';
export const BORROWER = 'Borrower';
export const APPLICANT = 'Applicant';
export const CHANNEL = 'channel';
export const ADVISOR_USER_CHANNEL = 'advisor_user_channel';
export const ADVISOR_REVIEWER_ADMIN = 'Reviewer (Admin)';
export const LOAN_OFFICER_CARDS = 'Loan Officer (Cards)';
export const LOAN_OFFICER_MORTGAGE = 'Loan Officer (Mortgage)';
export const LOAN_OFFICER_CONSUMER = 'Loan Officer (Consumer)';
export const PRODUCT_ADMIN = 'Admin (Cards,Consumer,Mortgage)';
export const LOAN_OFFICER_CARDS_SECURED = 'Loan Officer (Cards, Consumer)';
export const CREDIT_MANAGER = 'Credit Manager';
export const DIGITAL_RELATIONSHIP_MANAGER = 'Digital Relationship (Manager)';
export const CLOSED_LOAN_EDIT_MANAGER = 'Closed Loan Edit Manager';

export const EXISTING_IN_BRANCH_CUSTOMER = 'ExistingInBranchCustomer'
export const NEW_IN_BRANCH_CUSTOMER = 'NewInBranchCustomer'


// TODO: have to get rid of this static roles checking
export const ADVISOR_INVITE_ROLES = [
  ADVISOR_LOANOFFICER,
  ADMIN_LOANOFFICER,
  ADVISOR,
  UNDER_WRITER,
  ADVISOR_SUPER_ADMIN,
  ADMIN_UNDER_WRITER,
  LOAN_PROCESSOR,
  CREDIT_MANAGER,
  DIGITAL_RELATIONSHIP_MANAGER,
  CLOSED_LOAN_EDIT_MANAGER
];

export const MATIC_SOURCE_ID = '3333333333333333333';

// Chat page types
export const TEXT = 'text';
export const TASK = 'task';

// Default Values
export const DEFAULT_CITY = 'hoboken';
export const DEFAULT_STATE = 'NJ';
export const DEFAULT_MONTHLY_GROSS_PAY = 4803.46;
export const DEFAULT_DOWNPAYMENT = 10;
export const DEFAULT_LIABILITY = 691;

// TASK GROUPS
//
export const TASK_TYPE_GENERAL = 'GENERAL';
export const TASK_TYPE_MCQ_LONG_NAME = 'Multiple choice question (MCQ)';
export const TASK_TYPE_MCQ_SHORT_NAME = 'MCQ';
export const TASK_TYPE_BASICTEXTINPUT = 'Text Input';

export const TILE_BASICTEXTINPUT = 'Text input';
export const TITLE_BASICUPLOAD = 'Upload required documents';

export const TASK_TYPE_BASICUPLOAD = 'Collect Documents';
export const TASK_TYPE_GENERALUPLOADTEXT = 'General Upload & Text Input';

export const NAME_CONNECTOR = '_';

export const SSN = 'ssn';
export const DATE = 'date';
export const DATE_MONTH_YEAR = 'date_month_year';
export const LOE = 'loe';
export const TYPE_RADIO = 'radio';
export const TYPE_SWITCH = 'switch';
export const TYPE_CHECKBOX = 'checkbox';
export const TYPE_CHECKBOX_GROUP = 'checkbox_list';
export const TYPE_CHECKBOX_SINGLE_CHOICE = 'checkbox_single_choice';
export const TYPE_SINGLE_CHECKBOX = 'single_checkbox';
export const TYPE_DECLARATION_SWITCH = 'declaration_switch';
export const TYPE_DECLARATION_RADIO = 'declaration_radio';
export const TYPE_ADDRESS = 'address';
export const TYPE_DROPDOWN = 'dropdown';
export const TYPE_DROPDOWN_FILTER = 'dropdown_filter'
export const TYPE_AUTOCOMPLETE = 'autocomplete';
export const TYPE_AUTOCOMPLETE_MULTIPLE = 'autocomplete_multiple';
export const TYPE_HORIZONTAL_DIVIDER = 'horizontal_divider';
export const TYPE_HORIZONTAL_DIVIDER_INVISIBLE = 'horizontal_divider_invisible';
export const TYPE_SPACER_MARGIN = 'spacer_margin';
export const TYPE_SECTION_TITLE = 'section_title';
export const TYPE_DYNAMIC_AUTOCOMPLETE = 'dynamic_autocomplete';

export const TYPE_CARD_SECTION_TITLE = 'card_section_title';
export const TYPE_TEXT_AREA = "text_area"
export const TYPE_CHECKBOX_HEADER = 'checkbox_header';
export const TYPE_HIDDEN = 'hidden';
export const TYPE_ERROR_LABEL = 'error_label';
export const TYPE_WARNING_LABEL = 'warning_label';
export const TYPE_SUCCESS_LABEL = 'success_label';
export const TYPE_LABEL = 'info_label';

export const GENERAL = 'general';
export const BASIC_UPLOAD = 'basicupload';
export const GENERALUPLOADTEXT = 'uploadtext';
export const UPLOAD_DOCUMENTS = 'upload';
export const INDIVIDUAL = 'Individual';
export const JOINT_CREDIT = 'Joint credit';

export const NONE = 'none';
// Numbers
export const ZERO = '0';
export const ZERO_NUMBER = 0;
export const ONE = 1;
export const THREE = 3
export const HUNDRED = 100;

export const REOPEN = 'Reopen';
export const COMPLETED = 'Completed';


// Adviser gender
export const FEMALE_UPPERCASE_F_ONLY = 'F';
export const MALE_UPPERCASE_M_ONLY = 'M';
export const NEUTRAL_UPPERCASE = 'NEUTRAL';
export const NEUTRAL_LOWERCASE = 'neutral';
export const FEMALE_LOWERCASE = 'female';
export const MALE_UPPERCASE = 'MALE';
export const FEMALE_UPPERCASE = 'FEMALE';
export const MALE_LOWERCASE = 'male';

// These 3.2 fields
export const MARRIED_UPPERCASE_M_ONLY = 'M';
export const DIVORCED_UPPERCASE_D_ONLY = 'D';
export const SEPARATED_UPPERCASE_S_ONLY = 'S';
export const UNMARRIED_UPPERCASE_U_ONLY = 'U';
export const WIDOWED_UPPERCASE_W_ONLY = 'W';
// Show them visually we convert the 3.2 fields.
export const MARRIED_UPPERCASE_M = 'Married';
export const DIVORCED_UPPERCASE_D = 'Divorced';
export const WIDOWED_UPPERCASE_W = 'Widowed';
export const SEPARATED_UPPERCASE_S = 'Separated';
export const UNMARRIED_UPPERCASE_U = 'Unmarried';
export const OWNERSHIP_SHARE_LESS = 'Less than 25%';
export const OWNERSHIP_SHARE_GREATER = 'Greater than or equal to 25%';

export const US_CITIZEN = 'U.S. Citizen';
export const PERMANENT_RESIDENT = 'Permanent Resident Alien';
export const NON_PERMANENT_RESIDENT = 'Non-Permanent Resident Alien';



export const MATIC_PROVIDER_NAME = 'matic';
export const PROVIDER_TRANSUNION = 'TransUnion';
export const MATIC_QUOTE_AVAILABLE = 'quotes_available';

export const doNothing = (data?: any) => {
  return data
  // do nothing
};

export const doNothingPass = (data: any) => {
  return new Promise((resolve, reject) => {
    resolve(data)
  });
}
export const doNothingFail = (data: any) => {
  return new Promise((resolve, reject) => {
    reject(data)
  });
}

// Smartmatch quote percent
export const PERCENT_100 = '100%';
export const PERCENT_80 = '80%';

export const CLOUD_UPLOAD = 'cloud_upload';
export const SKIP_UPLOAD = 'skip_upload';

export const DONT_WANT_TO_SHARE_INFO = "I'd rather not share this info";


export const FEMALE_UPPERCASE_F = 'Female';
export const MALE_UPPERCASE_M = 'Male';

export const RACE_ASIAN = 'Asian';
export const RACE_AMERICAN_INDIAN = 'American Indian or Alaska Native';
export const RACE_BLACK = 'Black or African American';
export const RACE_HAWAIIAN = 'Native Hawaiian or Other Pacific Islander';
export const RACE_WHITE = 'White';
export const RACE_RATHER_NOT_SHARE =
  'I do not wish to provide this information';
export const RACE_SUB_ASIAN_INDIAN = 'Asian Indian';
export const RACE_SUB_FILIPINO = 'Filipino';
export const RACE_SUB_CHINESE = 'Chinese';
export const RACE_SUB_JAPANESE = 'Japanese';
export const RACE_SUB_KOREAN = 'Korean';
export const RACE_SUB_VIETNAMESE = 'Vietnamese';
export const RACE_SUB_OTHER_ASIAN = 'Other Asian';
export const WISH_TO_SHARE_ETHNICITY_INFO =
  "No, I don't wish to share my Ethnicity, Race & Sex";
export const ETHINICITY_TYPE_MEXICAN = 'Mexican';
export const ETHINICITY_TYPE_PUERTO_RICAN = 'Puerto Rican';
export const ETHINICITY_TYPE_CUBAN = 'Cuban';
export const ETHINICITY_TYPE_OTHERS = 'Other hispanic or latino';
export const ETHINICITY_HISPANIC_OR_LATINO = 'Hispanic or Latino';
export const ETHINICITY_OTHER_HISPANIC_OR_LATINO_ORIGIN =
  'Other Hispanic or Latino';
export const ETHINICITY_NOT_HISPANIC_OR_LATINO = 'Not Hispanic or Latino';
export const I_DO_NOT_WISH_TO_FURNISH_THIS_INFORMATION =
  'I_DO_NOT_WISH_TO_FURNISH_THIS_INFORMATION';
export const I_DO_NOT_WISH_TO_PROVIDE_THIS_INFORMATION =
  'I do not wish to provide this information';
export const NATIVE_HAWAIIAN = 'Native Hawaiian';
export const SAMOAN = 'Samoan';
export const OTHER_PACIFIC_ISLANDER = 'Other Pacific Islander';
export const GUAMANIAN_OR_CHAMORRO = 'Guamanian or Chamorro';

export const TYPE_OF_LOAN = 'type_of_loan';

export const BUSINESS_STREET = buildLabel('business_street');
export const BUSINESS_CITY = buildLabel('business_city');
export const BUSINESS_STATE = buildLabel('business_state');
export const BUSINESS_ZIPCODE = buildLabel('business_zipcode');
export const BUSINESS_COUNTRY = buildLabel('business_country');

export const APPLICANT_DOWNCASE_A = toLower(APPLICANT);
export const SKIP = 'Skip';

// Status
export const CLOSED = 'Closed';
export const READY = 'Ready';
export const ERROR = 'error';

export const STATUS_COMPLETED = 'Completed';
export const STATUS_CLOSED = 'Closed';
export const STATUS_REVIEW = 'Review';
export const STATUS_PROCESSING = 'Processing';
export const STATUS_IN_PROCESSING = 'In Processing';
export const STATUS_PENDING = 'Pending';
export const STATUS_DONE = 'Done';
export const STATUS_INPROGRESS = 'InProgress';
export const STATUS_ACCEPT = 'Accept';
export const STATUS_AWAITPENDING = 'AwaitPending';
export const STATUS_ACTIVE = 'Active';
export const STATUS_INACTIVE = 'Inactive';
export const STATUS_GOOD_STANDING = 'Good Standing';
export const STATUS_DISSOLVED = 'Dissolved';
export const STATUS_FORFEITED = 'Forfeited';
export const STATUS_CANCELLED = 'Cancelled';
export const STATUS_SUSPENDED = 'Suspended';
export const STATUS_EXISTS = 'Exists';
export const STATUS_NEW = 'New';
export const STATUS_STARTED = 'Started';

export const STATUS_SUBMITTED = 'Submitted';
export const STATUS_HIGHCREST_SUBMISSION = 'Highcrest Submission';
export const STATUS_ARCHIVED = 'Archived';
export const STATUS_DELETED = 'Deleted';
export const STATUS_MASKED = 'Masked';
export const STATUS_DENIAL_UNDER_REVIEW = 'Denial Under Review';
export const STATUS_CREDIT_APPROVAL = 'Credit Approval';
export const STATUS_CREDIT_MANAGEMENT = 'Credit Management';
export const STATUS_PRE_APPROVAL = 'Pre Approval';
export const STATUS_NOI_SENT = 'NOI Sent';
export const STATUS_ = 'Disable';
export const STATUS_CREATE = 'Create';
export const STATUS_UPLOADED = 'Uploaded';
export const STATUS_REVIWED = 'Reviwed';
export const STATUS_FUNDED = 'Funded';
export const STATUS_DELETING = 'Deleting';
export const STATUS_ARCHIVE = 'Archive';
export const STATUS_QUICK_DECLINE = 'Quick Decline';
export const STATUS_CLOSE = 'Close';
export const STATUS_DELETE = 'Delete';
export const STATUS_DECLINED = 'Declined';
export const STATUS_NOT_FUNDED = 'Not Funded';
export const BROKER_ALLOCATION = 'BrokerAllocation';
export const BROKER_ALLOCATION_READY = 'BrokerAllocation.Ready';
export const STATUS_HOME_APPRAISAL = 'Home Appraisal Appointment';
export const STATUS_TITLE = 'Title Appointment';
export const STATUS_REQUEST_APPROVAL = 'Request Approval';
export const STATUS_FINAL_APPROVAL = 'Final Approval';
export const STATUS_FINAL_CLOSING = 'Final closing';
export const STATUS_APPLICATION_IN_REVIEW = 'Application in review';
export const STATUS_SUBMITTED_FOR_ORDER = 'Submitted for Order';
export const STATUS_EXTENDED = 'Extended';
export const STATUS_UNTOUCHED = "Untouched";
export const STATUS_CENTRAL_GROUP_REVIEW = "Central Group Review";

export const STATUS_PRE_QUALIFICATION = `Prequalification`;
export const STATUS_CUSTOMER_WITHDRAWN = `Customer Withdrawn`;
export const STATUS_PRE_QUALIFIED = `Prequalified`;
export const STATUS_UNDERWRITING = `Underwriting`;
export const STATUS_FOLLOW_UP = `Followup`;
export const STATUS_OFFER = `Offers`;
export const STATUS_ACTIVE_OFFER = `Active Offers`;
export const STATUS_OFFER_PENDING = `Offer Pending`;
export const STATUS_CONTRACTS = `Contracts`;
// used in payments scheduler lambda(before changing check with worklets payments lambda)
export const STATUS_APPROVAL = 'Approval';
export const STATUS_HOLD = 'Hold';
export const STATUS_UN_HOLD = 'Unhold';
export const STATUS_RENEWED = 'Renewed';
export const STATUS_PAY_OFF = 'Pay-off';
export const STATUS_NOT_SCHEDULUED = 'Not scheduled';
export const STATUS_WAITING_FOR_APPROVAL = 'Waiting for approval';
export const STATUS_WRITE_OFF = 'Write-off';
export const STATUS_INVITATION_SENT = 'Invitation Sent';
export const STATUS_SAVED_PREQUALIFICATION = `Application Pending/Not Submitted`;
export const STATUS_APPLICATION_PENDING = 'Application Pending';
export const STATUS_APPLICATION_STARTED = 'Application Started';
export const STATUS_APPLICATION_SUBMITTED = `Application Submitted`;
export const STATUS_ACCEPTED = `Accepted`;
export const STATUS_INVITED = "Invited";
export const STATUS_INCOMPLETE_FOLLOWUP = `Application Incomplete`;
export const STATUS_UNDERWRITING_BR_OCROLUS = `Bank Review/Ocrolus`;
export const STATUS_UNDERWRITING_UNDER_REVIEW = `Underwriting Under Review`;
export const STATUS_UNDER_REVIEW = 'Under Review';
export const STATUS_ADDITIONAL_INFORMATION = 'Additional Information';
export const STATUS_SOFT_DECLINED = 'Soft Declined';
export const STATUS_RECOMMENDED_DECLINE = 'Recommended Decline';
export const STATUS_RECOMMENDED_APPROVE = 'Recommended Approve';
export const STATUS_UNDER_REVIEW_SPECIAL_CASE = 'Under Review Special Case';
export const APPRAISAL_ORDERED = 'Appraisal Ordered';
export const APPRAISAL_SCHEDULED = 'Appraisal Scheduled';
export const APPRAISAL_RECEIVED = 'Appraisal Received';
export const APPRAISAL_ACCEPTED = 'Appraisal Accepted';
export const STATUS_APPRAISAL_WAIVER = 'Appraisal Waiver';
export const STATUS_APPRAISAL_REQUESTED = 'Appraisal Requested';
export const STATUS_FINAL_VERIFICATION_OF_EMPLOYMENT = 'Final Verification of Employment';
export const STATUS_FACTOR = `Factor`;
export const STATUS_UNDERWRITING_PENDING_APPROVAL = `Underwriting Pending Approval`;
export const STATUS_CONTRACT_SENT = `Contract Sent`;
export const STATUS_EXPIRED_OFFERS = `Expired Offers`;
export const STATUS_CLOSING = `Closing`;
export const STATUS_ELIGIBLE = `Eligible`;
export const STATUS_SEND_TO_PROCESSING = 'Send to Processing';
export const STATUS_READY_FOR_DOCS = 'Ready for Document';
export const STATUS_DOCS_OUT = 'Docs Out';
export const STATUS_FUNDING = 'Funding';
export const STATUS_SHIPPING = 'Shipping';
export const STATUS_PURCHASING = 'Purchasing';
export const STATUS_COMPLETION = 'Completion';
export const STATUS_COND_APPROVAL = 'Cond Approval';
export const STATUS_RESUBMITTED = 'Resubmitted';
export const STATUS_WITHDRAW = 'Withdrawn';
export const STATUS_APPROVED_NOT_ACCEPTED = 'Approved Not Accepted';
export const STATUS_APPLICATION_APPROVED = 'Application Approved';
export const TITLE_RECEIVED = 'Title Received / Appraisal Received';
export const TITLE_APPRAISAL_RECEIVED = 'Title Received / Appraisal Received';
export const STATUS_APPLICATION_DENIED = 'Application Denied';
export const STATUS_CLEAR_TO_CLOSE_COMPLETED = 'Clear to Close';
export const STATUS_IN_PROCESS = 'In Process';
export const STATUS_LOAN_FUNDED = 'Loan Funded';
export const STATUS_DOCUMENTS_SIGNED = 'Doc Signing';
export const STATUS_APPRAISAL = 'Appraisal';
export const DOC_PREP = 'Doc Prep';
export const STATUS_APPLICATION_COMPLETED = 'Application Completed';
export const STATUS_APPLICATION = 'Application';
export const STATUS_APPROVED = 'Approved';
export const STATUS_APPRAISAL_ORDER = 'Appraisal Order';
export const STATUS_APPRAISAL_COMPLETE = 'Appraisal Complete';
export const STATUS_ACCOUNT_OPENED = 'Account Opened';
export const STATUS_APPROVED_PENDING_CONDITIONS = 'Approved Pending Conditions';



export const STATUS_APPROVED_PREMIUM = 'ApprovedPremium';
export const STATUS_FROZEN_CREDIT = 'Frozen Credit';
export const STATUS_CREDIT_ALERT = 'Credit alert';
export const STATUS_UNDERWRITING_APPROVAL = `Underwriting Approval`;
export const STATUS_LOAN_CLOSED = `Loan Closed`;
export const STATUS_BOOKING_COMPLETE = `Booking Complete`;
export const STATUS_BOOKED_TO_CORE = `Booked to Core`;



export const STATUS_CLOSED_FOR_INCOMPLETENESS = 'Closed for Incompleteness';
export const STATUS_DOCS_IN_EPRINT = 'Docs in E-Print';
export const STATUS_DOCS_IN_DOCUSIGN = 'Docs in DocuSign';

export const IS_DM_PROCEED = 'data merch hit and proceed';
export const DATA_MERCH_DECLINED_MESSAGE = 'Ineligible - DataMerch Hit';
export const DM_CONTINUE = 'continue';
export const DM_DECLINE = 'decline';

export const SHOW_ALL = 'Show all';

const NAOLD = 'n/a';
export const NULL_DASH = '-';


export const PRODUCT_OPTION_SELECT = 'Select'
export const PRODUCT_OPTION_PRIME = 'Prime'
export const PRODUCT_OPTION_BOTH = 'Both'

export const NALIST = [NULL_DASH, NAOLD];
export const EMPTY_ERROR = 'This field is required.';

export const PREQUALIFIED = "Prequalified";
export const INCOMPLETE = "Incomplete";

// used for MCA loan to collect user data before signup
export const PREQUALIFICATIONS_NAME = 'prequalification_name';
export const PREQUALIFICATIONS_BUSINESS_PHONE_NUMBER =
  'prequalification_business_phone_number';
export const PREQUALIFICATIONS_MONTHLY_REVENUE =
  'prequalification_monthly_revenue';
export const PREQUALIFICATIONS_REQUESTED_AMOUNT =
  'prequalification_requested_amount';
export const PREQUALIFICATIONS_FICO = 'prequalification_fico';

export const COPPER_CRM_LEAD_PROVIDER_NAME = 'copper_lead';
export const COPPER_CRM_OPPORTUNITY_PROVIDER_NAME = 'copper_opportunity';
// Notification constants
export const NOTIFICATION_TEMPLATE_SMS_SUBJECT = buildLabel(
  'notification_template/sms_subject'
);
export const NOTIFICATION_TEMPLATE_EMAIL_SUBJECT = buildLabel(
  'notification_template/subject'
);
export const NOTIFICATION_TEMPLATE_NAME = buildLabel(
  'notification_template/template_name'
);


export const ALL_CLOSED_APP_STATUS = [
  STATUS_LOAN_CLOSED,
  STATUS_BOOKING_COMPLETE,
  STATUS_ARCHIVED,
  STATUS_FUNDED,
  STATUS_DECLINED, STATUS_WITHDRAW
]

// Notification template namespace
export const READ = 'read';
export const UNREAD = 'unread';


export const USER_WORKFLOW_INTENT = 'userSpecificIntent';
/* Freddie mac Patch work  */
export const TYPE_OF_MORTGAGE_CONVENTIONAL = 'Conventional';

export const mandatoryIntentsForBC = [
  'business_owners',
  'tin_ein',
  'bank_statement',
  'business_name',
  'address',
  'time_in_business',
  'industry_type',
];
export const LOAN_STAGES_DROPDOWN_PLACEHOLDER_TEXT = 'Filter by Status';
export const LOAN_PRODUCT_DROPDOWN_PLACEHOLDER_TEXT = 'Filter by Product';
export const LOAN_COLLATERAL_DROPDOWN_PLACEHOLDER_TEXT = 'Filter by Collateral';
export const LOAN_PRIORITY_DROPDOWN_PLACEHOLDER_TEXT = 'Filter by Priority';
export const DEFAULT = 'default';
export const MAYBE_LATER = 'Maybe later';
export const REALTOR_MAILER_LENDSMART = 'REALTOR_MAILER_LENDSMART';
export const UPLOAD_SECTION = 'UPLOAD_SECTION';
export const SUMMARY_INTENT_ASSETS = 'SUMMARY_INTENT_ASSETS';

export const NEXT = 'Next';
export const PREVIOUS = 'Previous';
export const CONTINUE = 'Continue';
export const I_ACKNOWLEDGE = 'Acknowledge';
export const SUBMIT_APPLICATION = 'Submit Application';

export const PRIMARY_RESIDENCE_SAVED_AS = 'PrimaryResidence';
export const INVESTMENT_PROPERTY_SAVED_AS = 'InvestmentProperty';
export const SECOND_HOME_SAVED_AS = 'SecondHome';
export const FHA_SECONDARY_RESIDENCE_SAVED_AS = 'FHASecondaryResidence';

export const PREVIOUS_EMPLOYMENT_STATUS = 'Prior';
export const CURRENT_EMPLOYMENT_STATUS = 'Current';

export const ESTIMATED_MONTHLY_PAYMENT = 'Estimated monthly payment';
export const NET_ANNUAL_INCOME = 'Net annual income';

export const X_AUTH_LENDSMART_EXTERNAL_SERVICE = 'X-AUTH-LENDSMART-EXTERNAL-SERVICE';


// This is the maximum table row length for Tasks. Beyond this size the data will be ellipsized (...). When the user
// hovers overs the row the full task description is shown
export const MAX_TABLE_ROW_TEXT_LEN = 50;
export const MAX_TABLE_ROW_TEXT_LEN_SM = 35;
export const MAX_TABLE_ROW_BORROWER_NAME_LEN = 40;
export const MAX_TABLE_ROW_ASSIGNEE_LEN = 19;
export const MAX_TABLE_ROW_ASSIGNEE_LEN_MD = 12;
export const MAX_TABLE_ROW_ASSIGNEE_LEN_SM = 10;
export const MAX_TABLE_ROW_ASSIGNEE_NAME_LEN = 10;
export const DISABLED = 'Disabled';
export const WORKSPACE_TASK_COMPELETION_VALIDATOR = "WorkspaceAndTaskCompletionValidator";
export const DOCUSIGN_VALIDATOR = "DocuSignValidator";
export const CLEAR_TO_CLOSE_VALIDATOR = "ClearToCloseValidator";
export const CLEAR_TO_CLOSE_ONLY_MANDATORY_FIELDS = "ClearToCloseFieldsValidator";
export const MANDATORY_AND_TASK_COMPLETION_VALIDATOR = "MandatoryFieldAndTaskValidator";
export const MANDATORY_FIELDS_ONLY_VALIDATOR = "MandatoryFieldsValidator";
export const RECOMMENDED_APPROVED_VALIDATOR = "recommendedApprovedValidator";
export const DECLINED_VALIDATOR = "declinedValidator";
export const LOAN_PERMISSION_UPDATER = "loan_permission_updater";




